'use strict';

var _ = require('lodash');
var CurrentWorkflowTracker = function CurrentWorkflowTracker($rootScope, $log, $window, NavigationSectionConfig) {
  var MIN_WORKFLOW_TIME = 1;
  var DEFAULT_WORKFLOW_TITLE = 'AVFO';
  $rootScope.currentWorkflowTitle = DEFAULT_WORKFLOW_TITLE;
  $rootScope.currentWorkflow = '';
  $rootScope.previousWorkflow = null;
  $rootScope.currentWorkflowTimeEntered = null;
  function logPrevScreenStats() {
    if ($rootScope.currentWorkflow) {
      var key = _.replace($rootScope.currentWorkflow, 'app.', '');
      var value = (Date.now() - $rootScope.currentWorkflowTimeEntered) / 1000;
      if (value > MIN_WORKFLOW_TIME) {
        $log.metric(key, value, 'workflow-time');
      }
    }
  }
  function getDefaultWorkflowForScreen(name) {
    if (name.startsWith('app.market-analysis')) {
      return name + '.market';
    } else if (name.startsWith('app.flight-analysis')) {
      return name + '.cabin';
    } else {
      return name;
    }
  }
  function getScreenName() {
    var splitName = $rootScope.currentWorkflow.split('\.');
    return splitName[0] + '.' + splitName[1];
  }
  function getScreenTitle(name) {
    if (NavigationSectionConfig[name]) {
      return DEFAULT_WORKFLOW_TITLE + ' - ' + NavigationSectionConfig[name];
    }
  }
  function setCurrentWorkflow(currentWorkflow, previousWorkflow) {
    $rootScope.previousWorkflow = previousWorkflow;
    $rootScope.currentWorkflow = currentWorkflow;
    $rootScope.currentWorkflowTimeEntered = Date.now();
    $rootScope.currentWorkflowTitle = getScreenTitle($rootScope.currentWorkflow) || getScreenTitle(getScreenName());
  }
  $rootScope.$on('$stateChangeStart', function (evt, nextState) {
    logPrevScreenStats();
    setCurrentWorkflow(getDefaultWorkflowForScreen(nextState.name));
  });
  $rootScope.$on('IdleStart', function () {
    logPrevScreenStats();
    $rootScope.currentWorkflowBeforeIdle = $rootScope.currentWorkflow;
    $rootScope.currentWorkflow = null;
    $rootScope.currentWorkflowTimeEntered = null;
  });
  $rootScope.$on('IdleEnd', function () {
    $rootScope.currentWorkflow = $rootScope.currentWorkflowBeforeIdle;
    $rootScope.currentWorkflowTimeEntered = Date.now();
    $rootScope.currentWorkflowBeforeIdle = null;
  });
  $rootScope.$on('workflow-tab-changed', function (evt, newTab, isShown) {
    logPrevScreenStats();
    var screen = getScreenName();
    var newWorkflow = screen + '.' + newTab;
    if ($rootScope.currentWorkflow.startsWith('app.market-analysis')) {
      if (isShown) {
        setCurrentWorkflow(newWorkflow, $rootScope.currentWorkflow);
      } else {
        setCurrentWorkflow($rootScope.previousWorkflow);
      }
    } else if ($rootScope.currentWorkflow.startsWith('app.flight-analysis')) {
      if (newTab === 'flight-management') {
        // we go to Flight Management - remember where to get back
        setCurrentWorkflow(newWorkflow, $rootScope.currentWorkflow);
      } else if (newTab === 'flight-analysis') {
        // we go back from Flight Management
        setCurrentWorkflow($rootScope.previousWorkflow);
      } else {
        setCurrentWorkflow(newWorkflow);
      }
    } else {
      setCurrentWorkflow(newWorkflow);
    }
  });
  $rootScope.$on('market-analysis-toggle:toggleMode', function (evt, nextState) {
    logPrevScreenStats();
    setCurrentWorkflow(getScreenName() + '.' + nextState);
  });
  $window.addEventListener('beforeunload', function () {
    logPrevScreenStats();
  });
};
CurrentWorkflowTracker.$inject = ['$rootScope', '$log', '$window', 'NavigationSectionConfig'];
module.exports = CurrentWorkflowTracker;